export const styles = () => {
  return {
    avatarCircle: {
      display: 'flex',
      alignItems: 'center' as 'center',
      justifyContent: 'center' as 'center',
      flexDirection: 'row' as 'row',
      gap: 4,
      borderWidth: 0,
      position: 'relative' as 'relative',
    } as React.CSSProperties,
  };
};
